// extracted by mini-css-extract-plugin
export default {"company-header":"Header_company-header__B7MvT","company-header-item":"Header_company-header-item__CgqB3"};